import React from "react";
import Step from "./Step";

const Stepper = (props) => {
    {
        return props.steps.map((step, index, arr) => {
            let isActive = props.isActive === step.label;
            let lastStep = arr.length - 1 === index;

            return <Step label={step.label} content={step.content} isActive={isActive} lastStep={lastStep}/>
        })
    }
}

export default Stepper;